module.exports = __webpack_public_path__ + "static/bass-culture-ffb2d8ad87216eb2f60e44ebb229fbd3.jpg";